export const pl = {
  title: 'Nota prawna (Impressum)',
  subtitle: 'Informacje obowiązkowe zgodnie z rozporządzeniem UE 2018/302 oraz estońskim kodeksem handlowym (äriseadustik) · Stan: 10.05.2026',
  sections: [
    {
      id: 'company',
      title: 'Usługodawca',
      body:
        '**MATTALNET GRUPP OÜ**\nTuukri tn 19-315\n10120 Tallinn, Estonia\n\n- **Registrikood (numer w rejestrze handlowym):** 14744075\n- **NIP UE / numer KMKR:** EE102519059\n- **EORI:** EE14744075\n- **D-U-N-S:** 536415812\n- **Rejestr:** Eesti äriregister (estoński rejestr handlowy)\n- **Forma prawna:** Osaühing (OÜ) — spółka z ograniczoną odpowiedzialnością według prawa estońskiego\n- **Dopuszczona do działalności i regulowana w:** Republice Estońskiej, Unii Europejskiej',
    },
    {
      id: 'responsible',
      title: 'Osoba odpowiedzialna za treść',
      body:
        '**Andreas A. Gleim**\nDyrektor zarządzający / osoba odpowiedzialna za treść zgodnie z estońskim kodeksem handlowym (äriseadustik) oraz § 18 MStV (Niemcy)\n\nE-mail: [logixa.one/kontakt](/kontakt)',
    },
    {
      id: 'contact',
      title: 'Kontakt',
      body:
        'E-mail: [logixa.one/kontakt](/kontakt)\nStrona internetowa: [https://logixa.one](https://logixa.one)\n\nZapytania dotyczące platformy, partnerstwa, prasy oraz ochrony danych można kierować na powyższy adres e-mail lub poprzez [formularz kontaktowy](/kontakt).',
    },
    {
      id: 'eu',
      title: 'Pozasądowe rozstrzyganie sporów UE',
      body:
        'Komisja Europejska udostępnia platformę do internetowego rozstrzygania sporów (ODR):\n\n[https://ec.europa.eu/consumers/odr/](https://ec.europa.eu/consumers/odr/)\n\nNie jesteśmy ani gotowi, ani zobowiązani do udziału w postępowaniu rozjemczym przed organem do spraw polubownego rozstrzygania sporów konsumenckich.',
    },
    {
      id: 'liability',
      title: 'Odpowiedzialność za treści',
      body:
        'Jako usługodawca ponosimy zgodnie z § 7 ust. 1 TMG (Niemcy) oraz estońską ustawą InfoTS odpowiedzialność za własne treści na tych stronach na zasadach ogólnych. Zgodnie z §§ 8 do 10 TMG nie jesteśmy jednak jako usługodawca zobowiązani do monitorowania przekazywanych lub przechowywanych cudzych informacji.\n\nObowiązki usunięcia lub zablokowania korzystania z informacji wynikające z przepisów ogólnych pozostają nienaruszone. Odpowiedzialność w tym zakresie jest jednak możliwa dopiero od momentu powzięcia wiedzy o konkretnym naruszeniu prawa.',
    },
    {
      id: 'liability-links',
      title: 'Odpowiedzialność za odnośniki',
      body:
        'Nasza oferta zawiera odnośniki do zewnętrznych witryn osób trzecich, na których treść nie mamy wpływu. Dlatego nie możemy również ponosić żadnej odpowiedzialności za te cudze treści. Za treści stron, do których prowadzą odnośniki, zawsze odpowiada ich dostawca lub operator.',
    },
    {
      id: 'copyright',
      title: 'Prawa autorskie',
      body:
        'Treści i dzieła utworzone przez operatorów stron na tych witrynach podlegają prawu autorskiemu. Powielanie, opracowywanie, rozpowszechnianie oraz wszelkiego rodzaju wykorzystywanie wykraczające poza granice prawa autorskiego wymagają pisemnej zgody odpowiedniego autora lub twórcy.\n\nPobieranie i kopiowanie tej strony jest dozwolone wyłącznie do prywatnego, niekomercyjnego użytku.',
    },
  ],
};
